import template from './addFundingPairModal.html';
import controller from './addFundingPairModal.controller';

let AddFundingPairModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

AddFundingPairModalComponent.template = template;
AddFundingPairModalComponent.controller = controller;

export default AddFundingPairModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addFundingPairModal/addFundingPairModal.component.js